import React, { useState } from "react";
import {
	List,
	MenuItem,
	ListItemIcon,
	Typography,
	Collapse,
	Tooltip,
} from "@mui/material";
import { useTranslate, useSidebarState } from "react-admin";
import ExpandMore from "@mui/icons-material/ExpandMore";

const SubMenu = ({ name, icon, children, isSubMenuOpen = false }) => {
	const translate = useTranslate();
	const [isOpen, setIsOpen] = useState(isSubMenuOpen);
	const [sidebarIsOpen] = useSidebarState();

	const handleToggle = () => {
		setIsOpen((prevState) => !prevState);
	};

	const header = (
		<MenuItem onClick={handleToggle}>
			<ListItemIcon sx={{ minWidth: 5 }}>
				{isOpen ? <ExpandMore /> : icon}
			</ListItemIcon>
			<Typography variant="inherit" color="textSecondary">
				{translate(name)}
			</Typography>
		</MenuItem>
	);

	return (
		<div>
			{sidebarIsOpen || isOpen ? (
				header
			) : (
				<Tooltip title={translate(name)} placement="right">
					{header}
				</Tooltip>
			)}
			<Collapse in={isOpen} timeout="auto" unmountOnExit>
				<List
					component="div"
					disablePadding
					sx={{
						"& .MuiMenuItem-root": {
							transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
							paddingLeft: "2em",
						},
					}}
				>
					{children}
				</List>
			</Collapse>
		</div>
	);
};

export default SubMenu;
